<template>
    <div class="menu-wrap" :class="{ '__ism': isMobile, '__is-open': isOpen }" @click.self="handleClickHamb">
        <div class="container" @click.self="handleClickHamb">
            <ul class="__mo">
                <li class="logo"><img :src="menu.logo"></li>
                <Transition mode="out-in">
                    <li v-if="!isOpen" class="hamb"><button @click.stop="handleClickHamb"><img :src="menu.hamb"></button></li>
                    <li v-else class="hamb"><button @click.stop="handleClickHamb"><img :src="menu.close"></button></li>
                </Transition>
            </ul>
            <Transition>
                <ul v-if="isOpen" class="__tree" :class="{ '__ism': isMobile }">
                    <li v-if="isMobile">
                        <!-- <button
                            @click="handleClickBayTicket"
                            >Купить билет
                        </button> -->
                        <button
                            @click="handleClickButtonConsult"
                            >Обратиться к спикерам
                        </button>
                    </li>
                    <li v-for="(item, index) in menu.tree" :key="index"><a :href="item.href" @click="handleClickHamb">{{ item.title }}</a></li>
                    <li v-if="!isMobile">
                        <!-- <button @click="handleClickBayTicket"
                        >Купить билет</button> -->
                        <button @click="handleClickButtonConsult"
                        >Обратиться к спикерам</button>
                    </li>
                    <li v-if="isMobile" class="__buttons">
                        <button><img :src="menu.tg" alt=""></button>
                        <button><img :src="menu.wa" alt=""></button>
                    </li>
                </ul>
            </Transition>
        </div>
    </div>
</template>
<script>
import menu from '@/lib/menu'
export default {
    name: 'MainMenu',
    components: {},
    emits: [ 'clickButton', 'clickButtonConsult' ],
    props: {},
    data() {
        return {
            menu,
            isOpen: false,
            isMobile: false,
        }
    },
    mounted() {
        this.handleResize()
        window.addEventListener( 'resize', this.handleResize )
    },
    methods: {
        handleClickHamb: function() {
            this.$emit('clickButton')
            if ( !this.isMobile ) {
                return
            }
            this.isOpen = !this.isOpen
            document.body.style.overflow = this.isOpen ? 'hidden' : ''
        },
        handleResize: function() {
            if ( document.body.clientWidth > 992 ) {
                this.isOpen = true
                this.isMobile = false
            } else {
                this.isOpen = false
                this.isMobile = true
            }
        },
        handleClickBayTicket: function() {
            if ( this.isMobile ) {
                this.isOpen = false
                document.body.style.overflow = this.isOpen ? 'hidden' : ''
            }
            document.querySelector('#tariff').scrollIntoView()
            window.scrollBy( 0, -60 )
        },
        handleClickButtonConsult: function() {
            this.$emit( 'clickButtonConsult' )
        },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
.menu-wrap{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 20;
    
    a{
        color: #fff;
        text-decoration: none;
        // line-height: 0;
    }
    button{
        background-color: $primary;
        border: none;
        border-radius: 50px;
        font-size: 1em;
        // height: 25px;
        color: #fff;
        padding: 8px 16px;
        cursor: pointer;
        transition: .4s;
        &:hover{
            transition: .4s;
            color: $primary;
            background: #fff;
        }
    }
    ul{
        padding: 0 20px;
        margin: 0;
        list-style: none;
        display: flex;
        align-items: center;
        background-image: linear-gradient( 45deg, #350098, #0a327c );
        // width: 100%;
        height: 50px;
        @media ( min-width: 992px ) {
            border-radius: 16px;
        }
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        li{
            margin-right: 16px;
            &:last-child{
                flex-grow: 1;
                margin-right: 0;
                text-align: right;
                margin-bottom: 0;
            }
            a{
                color: #dedede;
                display: block;
                padding: 2px;
                border-bottom: 1px solid #1e9ad800;
                transition: .3s;
                border-bottom-width: 0%;
                &:hover{
                    color: #ffffff;
                    transition: .3s;
                    border-bottom: 1px solid #ffffff;
                    border-bottom-width: 90%;
                }
            }
        }
    }
    .__mo{
        display: none;
        margin: 0;
        padding: 0;
        
        transition: .4s;

        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        // width: 100%;
        .logo{
            display: flex;
            align-items: center;
            padding: 5px 0 5px 15px;
            margin: 0;
            object-fit: cover;
            // flex-shrink: 0;
            img{
                // height: 25px;
                // width: 123px;
                // @media (min-width: 300px) {
                    // height: 46px;
                    // width: 190px;
                // }
                height: auto;
                width: 100%;
                max-height: 46px;
            }
        }
        .hamb{
            display: flex;
            // flex-wrap: 1;
            justify-content: end;
            align-items: center;
            padding: 0px 10px 0px 0px;
            margin: 0;
            button{
                background: none;
            }
        }
    }
    .container{
        display: flex;
        flex-direction: column;
    }
    .__ism.__tree{
        width: 100%;
        transition: .4s;
        @media ( min-width: 320px ) {
            width: 90%;
        }
        @media ( min-width: 574px ) {
            width: 80%;
            // font-size: 1.25em;
        }
        align-self: flex-end;
        li{
            border-bottom: solid 1px #fff;
            margin: 0 0 20px 0;
            width: 90%;
            padding: 5px 0;
            text-align: left;
            &:first-child{
                border: none;
                button{
                    text-transform: uppercase;
                    // padding: 15px;
                    width: 100%;
                    height: 40px;
                    font-size: 1em;
                }
            }
            &.__buttons{
                border: none;
                button{
                    width: 60px;
                    height: 60px;
                    margin-right: 10px;
                    padding: 2px;
                    // border: solid 1px #1E9BD8;
                    border-radius: 100%;
                    // background: #350098;
                    line-height: 0;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }
    &.__ism.__is-open{
        height: 100%;
        .__mo{
            transition: .4s;
            border-bottom-right-radius: 0;
            @media ( max-width: 320px ) {
                border-bottom-left-radius: 0;    
            }
        }
        .__tree{
            transition: .4s;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    }
    @media ( max-width: 992px ) {
        .__mo{
            display: flex;
        }
        ul{
            padding: 25px 0;
            height: auto;
            // width: 100%;
            flex-direction: column;
            li{
                margin-bottom: 20px;
            }
        }
    }
    // &.__top{
    // }
}
</style>